<p-toast [style]="{margin: '50px'}"></p-toast>
<router-outlet></router-outlet>
